import React from 'react';
import './GiantPipe.scss';
import InfoBalls from './InfoBalls';
export default ({ isActive }) => {
  return (
    <div className="giant-pipe-container">
      <InfoBalls />
    </div>
  );
};